import "@hotwired/turbo-rails"
import "../confirm_modal"
import { Application } from "@hotwired/stimulus"
import { configure as configureLexxy } from "@37signals/lexxy"
// The package's `exports` map doesn't expose the stylesheet subpath, so the
// editor + rendered-content styles are imported by filesystem path.
import "../../../node_modules/@37signals/lexxy/dist/stylesheets/lexxy.css"

// Rich text editing (admin Client Information). Attachments are disabled —
// no Active Storage in this app; the editor value is plain HTML submitted
// with the form.
configureLexxy({
  default: { attachments: false }
})

const application = Application.start()
application.debug = false
window.Stimulus = application

const controllers = import.meta.glob("../controllers/*_controller.js", { eager: true })
for (const path in controllers) {
  const name = path.match(/controllers\/(.+)_controller\.js$/)?.[1]?.replace(/_/g, "-")
  if (name && controllers[path].default) application.register(name, controllers[path].default)
}

export { application }
